module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "a07_poem"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Long ago we were boys in the ranks comrades,"), _c('br'), _vm._v(" Our hearts light and happy as the day,"), _c('br'), _vm._v(" Cheeks were ruddy, eyes bright, locks dark, comrades,"), _c('br'), _vm._v(" As we marched from our homes far away.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("But now we are aged and gray comrades,"), _c('br'), _vm._v(" The trials of life are nearly done,"), _c('br'), _vm._v(" But to us life’s as dear as it was comrades,"), _c('br'), _vm._v(" When you and I were young.")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', [_vm._v("—Long Ago")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERSE ONE AND CHORUS "), _c('br'), _vm._v("BY")]), _vm._v(" J. M. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARMICHAEL")]), _vm._v(", 1902 "), _c('br'), _c('i', [_vm._v("(recorded by Bobby Horton Music)")])])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6f98ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_poem.vue
// module id = 75
// module chunks = 0